import $ = require("jquery");

var winAny = window as any;
winAny.appBlog ??= {};
winAny.appBlog.init ??= initAppBlog;

function initAppBlog({ domAttribute }: { domAttribute: string }) {
    const _blogTabWrapper = document.getElementById('NextBio_Top_Blog_agg_tabstrip') as HTMLElement;
    const _tabOpener = _blogTabWrapper.querySelectorAll('li.nav-item') as NodeListOf<HTMLElement>;
    _tabOpener.forEach((elem: HTMLElement) => {
        elem.addEventListener('click', (event) => {
            _tabOpener.forEach((inActiveElem: HTMLElement) => {
                inActiveElem.classList.remove('active');
            });
            if (!elem.classList.contains('active')) {
                elem.classList.add('active');
            }
        });
    });
}

///* 2/2 change content base on select */
//$(document).ready(function(){
//  /* set the deafult select-menu value */
//  $("#mobileMnu").change(function(e){
//    var curTabId = $(this).val();
//    $('curTabId').tab('show')
//    console.log(JSON.stringify(curTabId));
//    $("#" + curTabId + " > a").trigger('click');
//  });   
//});

export function CategoryTabs(cat: Category){ 
    return `
    <ul class="expanded">
        <li data-tab="Tab0" id="Tab0" onclick="javascript:SelectTab(0);" class="NextBio_Top_Blog_TabSelected">
            <a id="Tab0_link" href="https://dotnextnuke-staging.azurewebsites.net/Blog/All?category=biologics">
                <input type="hidden" id="Tab0_CheckVal" value="all">
                <span>
                    <span id="Tab${cat.Key}_Text" class="NextBio_Top_Blog_TabUnselected">${cat.Value}</span>
                </span>
                <span class="submenu-indicator">+</span>
            </a>
        </li>
    </ul>
    `
}

function BlogPost(post: Post) {
  return `
          <div class="row">
            <div class="col">
                <article class="app-blog5-list-item">
                    <div class="row mb-3">
                        <a href="/Blog/All/details/${post.UrlKey}">
                        <div class="row mb-3" >
                            <div class="col-md-12 col-lg-6 col-sm-12 float-left" style="background-color:rgb(240,240,240)">
                                    <img class="img-fluid list-img" src="${post.Image}" alt="Alternate Text">
                            </div>
                            <div class="col-md-12 col-lg-6 col-sm-12 py-4" style="background-color:rgb(240,240,240)">
                                <div tabindex="0" class="content-title p-2">
                                    <span style="font-family: RopaSoftPro-Regular; font-size: 20px; line-height: 1.2em; letter-spacing: 1px; font-weight: 600; font-style: normal; color: rgb(80, 80, 80); text-decoration: none; text-shadow: none; text-transform: none;">${post.Title} </span><br>
                                </div>
                                <div class="separator-container">
                                    <div class="separator dotted"></div>
                                </div>
                                <div class="content-paragraph w-75 p-2">
                                <p>${post.Content}</p>
                                </div>
                                <div class="float-right">
                                    <span class="button toggle-button blog-toggle-button">
                                        <div class="x-symb">
                                            <div class="dot dot-blue"></div>
                                            <div class="vert-line line line-blue line-w"></div>
                                            <div class="ori-line  line-blue line line-w"></div>
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </a>
                    </div>
                </article>  
            </div>
        </div>
        `
}

type Category = {
    Key:string
    Value: string,
    posts: Post[]
}
type Post = {
      Title: string,
      UrlKey: string,
      Image: string,
      Content: any,
      Teaser:string,
}
const deafultValue = 1; /* set Active: index start from zero */
